import { cdn } from "constants/common";
import React from "react";
import { Table } from "reactstrap";

const TransLogsTable = ({ item }) => {
  // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
  const renderTableHeader = React.useCallback(() => {
    return (
      <tr>
        <th className="col-3">Doc Name</th>
        {/* <th className="col-2">Total Words Count</th> */}
        {/* <th className="col-2">Estimated Words Count</th> */}
        {/* <th className="col-2">Total Estimated Amount</th> */}
      </tr>
    );
  }, []);

  const renderTableContent = React.useCallback((item) => {
    return <LogItem item={item} key={item?.id} />;
  }, []);

  return (
    <div className="table_responsive">
      <table className="table">
        <thead className="text-primary">{renderTableHeader()}</thead>
        <tbody>
          {item?.translation_files &&
            item?.translation_files?.map((item) => renderTableContent(item))}
        </tbody>
      </table>
    </div>
  );
};


const LogItem = ({ item }) => {
  return (
    <tr>
      <td className="col-3">
        <a href={/^https?:\/\//i.test(item?.original_file ?? '') ? item.original_file : cdn + item?.original_file} target="_blank">{item?.original_file_name || "N/A"}</a>
      </td>
      {/* <td className="col-2">{item?.word_count ?? "N/A"}</td> */}
      {/* <td className="col-2">{item?.est_words_count ?? 0}</td> */}
      {/* <td className="col-2">$ {item?.amount ?? 0}</td> */}
    </tr>
  );
};
export default TransLogsTable;
